import { Result } from '../../shared/models/core/result.model';
import { AuditTrail } from '../../shared/models/audit_trail.model';

export interface AuditTrailManagementState {
    auditTrailResult: Result<AuditTrail> | null;
    selectedAuditTrail: AuditTrail | null;
    error: any;
}

export const initialState: AuditTrailManagementState = {
    auditTrailResult: null,
    selectedAuditTrail: null,
    error: null
};
